<div *ngIf="showRequest" class="">
  <h2 class="sectionTitle"></h2>
  <form #heroForm="ngForm"> 
    <div class="form-container">
      <h4 class="section-title" *ngIf="displayedLang == 'Ar'">
        <div *ngFor="let ETCat of model?.ETendersCategories">{{ETCat.NameAR}}
        </div>
      </h4>
      <h4 class="section-title" *ngIf="displayedLang == 'En'">
        <div *ngFor="let ETCat of model?.ETendersCategories">{{ETCat.NameEN}}
        </div>
      </h4>
    </div>
    <div class="row" *ngIf="model != null">
    
        <div class="col-md-3 col-md-push-9 col-xs-12"> 

        </div>
        <div class="col-md-9 col-md-pull-3 col-xs-12">
          <div class="tender-info-holder">
            <div>
              <span class="icon-file" *ngIf="model.FileNumber != null"></span>
              <p>{{'ADMIN_USER.E_TENDER_FORM.FILE_NUMBER'|translate}}</p>
              <p>{{model.FileNumber}}</p>
            </div>
            <div>
              <span class="icon-tenders" *ngIf="model.TenderNumber != null"></span>
              <p>{{'ADMIN_USER.E_TENDER_FORM.TENDER_NUMBER'|translate}}</p>
              <p>{{model.TenderNumber}}</p>
            </div>
            <div>
              <span class="icon-map-pin" *ngIf="model.SessionPlaceAR != null || model.SessionPlaceEN != null"></span>
              <p>{{'ADMIN_USER.E_TENDER_FORM.SESSION_PLACE'|translate}}</p>
              <p>{{model.SessionPlaceAR}}</p>
              <p>{{model.SessionPlaceEN}}</p>
            </div>
            <div>
              <span class="icon-calendar" *ngIf="model.PublishingDate != null"></span>
              <p>{{'ADMIN_USER.E_TENDER_FORM.PUBLISH_DATE'|translate}}</p>
              <p>{{model.PublishingDate}}</p>
            </div>
          </div>
          <div class="tender-body-info">
            <div class="form-container">
              <h4 class="section-title">{{'ADMIN_USER.E_TENDER_FORM.BASIC_INFO' | translate }}</h4>
            </div>
              <div class="form-container full-width" *ngIf="model.TitleEN != null">
                <div class="form-group">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.TITLE_EN' | translate}}</label>
                  <p>{{model.TitleEN}}</p>
                </div>
              </div>
              <div class="form-container full-width" *ngIf="model.TitleAR != null">
                <div class="form-group">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.TITLE_AR' | translate}}</label>
                  <p>{{model.TitleAR}}</p>
                </div>
              </div>
              <div class="form-container full-width" *ngIf="oldSelectedSuppliers != null">
                <div class="form-group">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.ETENDERS_SUPPLIERS' | translate}}</label>
                  <ol  style="-webkit-columns: 3;
                    -moz-columns: 3;
                    columns: 3;">
                <li *ngFor="let supplier of oldSelectedSuppliers">
                  {{supplier.CompanyName}}
                </li>
              </ol>
                </div>
              </div>
<!-- 
                <div class="form-group" *ngIf="model.TenderTypeId != null">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.TENDER_TYPE' | translate}}</label>
                  <p *ngIf="displayedLang == 'En'">{{TenderType.NameEN}}</p>
                  <p *ngIf="displayedLang == 'Ar'">{{TenderType.NameAR}}</p>
                </div>
                <div class="form-group" *ngIf="model.FinancialYear != null">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.FINANCIAL_YEAR' | translate}}</label>
                  <p>{{model.FinancialYear}}</p>
                </div>
                <div class="form-group" *ngIf="model.TenderMethodId != null">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.TENDER_METHOD' | translate}}</label>
                  <p *ngIf="displayedLang == 'En'">{{TenderMethod.NameEN}}</p>
                  <p *ngIf="displayedLang == 'Ar'">{{TenderMethod.NameAR}}</p>
                </div>
                <div class="form-group" *ngIf="model.HaveMaintenanceContract != null">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.HAVE_MAINTENANCE_CONTRACT' | translate}}</label>
                  <p>{{ model.HaveMaintenanceContract.toString() | translate}}</p>
                </div>
                <div class="form-group" *ngIf="model.MaintenanceContractValue != null">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.MAINTENANCE_CONTRACT_VALUE' | translate}}</label>
                  <p>{{model.MaintenanceContractValue}}</p>
                </div>
                <div class="form-group" *ngIf="model.AcceptRetail != null">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.MUST_ACCEPT_RETAIL' | translate}}</label>
                  <p>{{model.AcceptRetail.toString() | translate}}</p>
                </div>
                <div class="form-group" *ngIf="model.HaveAlternativeOffers != null">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.ALTERNATIVE_OFFERS_ALLOWED' | translate}}</label>
                  <p>{{model.HaveAlternativeOffers.toString() | translate}}</p>
                </div>
                <div class="form-group" *ngIf="model.EvaluationSystemId != null">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.EVALUATION_SYSTEM' | translate}}</label>
                  <p *ngIf="displayedLang == 'En'">{{EvaluationSystem.NameEN}}</p>
                  <p *ngIf="displayedLang == 'Ar'">{{EvaluationSystem.NameAR}}</p>            
                </div>
                <div class="form-group" *ngIf="model.MinimumAcceptancePointsForTechnicalOffer != null">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.MINIMUM_ACCEPTANCE_POINTS_FOR_TECHNICAL_OFFER' | translate}}</label>
                  <p>{{model.MinimumAcceptancePointsForTechnicalOffer}}</p>
                </div>
              </div>
              <div class="form-container full-width" *ngIf="model.CommentsEN != null">
                <div class="form-group">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.ENGLISH_COMMENTS' | translate}}</label>
                  <p>{{model.CommentsEN}}</p>
                </div>
              </div>
              <div class="form-container full-width" *ngIf="model.CommentsAR != null">
                <div class="form-group">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.ARABIC_COMMENTS' | translate}}</label>
                  <p>{{model.CommentsAR}}</p>
                </div>
              </div>
              <div class="form-container">
                <div class="form-group" *ngIf="model.OfferDeadline != null">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.OFFER_DEADLINE' | translate}}</label>
                  <p>{{model.OfferDeadline}}</p>
                  <p>{{model.OfferDeadlineTime}}</p>
                </div>
                <div class="form-group" *ngIf="model.ClarificationDurationStartDate != null">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.CLARIFICATION_DURATION_START_DATE' | translate}}</label>
                  <p>{{model.ClarificationDurationStartDate}}</p>
                  <p>{{model.ClarificationDurationStartTime}}</p>
                </div>
                <div class="form-group" *ngIf="model.ClarificationDurationEndDate != null">
                  <label>{{'ADMIN_USER.E_TENDER_FORM.CLARIFICATION_DURATION_END_DATE' | translate}}</label>
                  <p>{{model.ClarificationDurationEndDate}}</p>
                  <p>{{model.ClarificationDurationEndTime}}</p>
                </div> -->
              </div>
          <div class="form-container">
            <h4 class="section-title">{{'ADMIN_USER.E_TENDER_FORM.INVITE_ADDITIONAL_SUPPLIER' | translate }}</h4>
            <div class="form-group">
              <label *ngIf="model.Suppliers && model.Suppliers.length > 0" for="category">{{ 'ADMIN_USER.E_TENDER_FORM.ETENDERS_SUPPLIERS' | translate }}</label>
            <ng-multiselect-dropdown *ngIf="model.Suppliers && model.Suppliers.length > 0"
            id="suppliers"
            placeholder="{{ 'ADMIN_USER.SHARED.CHOOSE' | translate }}"
            [settings]="suppliersDropdownSettings"
            [data]="model.Suppliers"
            [(ngModel)]="selectedSuppliers"
            (onDropDownClose)="SuppliersChanged()"
            name="suppliers">
          </ng-multiselect-dropdown>
          <p *ngIf="model.Suppliers && model.Suppliers.length == 0">{{'ADMIN_USER.E_TENDER_FORM.ALLINVITED' | translate}}</p>
          </div>
          </div>
        </div>
        </div>
        <div class="form-group" *ngIf="showSubmit">
          <button [disabled]="loading" class="btn btn-primary SCAcustomBtn" Confirmation
            (confirmationClick)="onSubmit()">{{ 'FRONT_USER.SUBMIT' | translate}}
            </button>
        </div>
  </form>
</div>
<!-- Confirmation -->
<div *ngIf="!showRequest && IsSuccess" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p> {{ message }}</p>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

